import { render, staticRenderFns } from "./audit-trail-role.vue?vue&type=template&id=58488338&"
import script from "./audit-trail-role.vue?vue&type=script&lang=js&"
export * from "./audit-trail-role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports